import request from '@/utils/request';

export function queryPinTuanGoodsPageList(data) {
  return request({
    url: '/pin/tuan/goods/queryPinTuanGoodsPageList',
    method: 'POST',
    data
  });
}
// 键删除拼团商品
export function removePinTuanGoodsById(data) {
  return request({
    url: '/pin/tuan/goods/removePinTuanGoodsById',
    method: 'POST',
    data
  });
}
// 查询所有上架的商品列表
export function queryAllEnableGoodsList(data) {
  return request({
    url: '/pin/tuan/goods/queryAllEnableGoodsList',
    method: 'POST',
    data
  });
}
// 获取拼团商品明细
export function fetchPinTuanGoodsDetailById(data) {
  return request({
    url: '/pin/tuan/goods/fetchPinTuanGoodsDetailById',
    method: 'POST',
    data
  });
}
// 新增拼团商品
export function savePinTuanGoods(data) {
  return request({
    url: '/pin/tuan/goods/savePinTuanGoods',
    method: 'POST',
    data
  });
}
// 修改拼团商品
export function updatePinTuanGoods(data) {
  return request({
    url: '/pin/tuan/goods/updatePinTuanGoods',
    method: 'POST',
    data
  });
}
// 启用或关闭拼团商品
export function enablePinTuanGoodsById(data) {
  return request({
    url: '/pin/tuan/goods/enablePinTuanGoodsById',
    method: 'POST',
    data
  });
}
// 拼团订单列表
export function queryPinTuanOrderPageList(data) {
  return request({
    url: '/pin/tuan/order/queryPinTuanOrderPageList',
    method: 'POST',
    data
  });
}
// 根据团长ID获取拼团订单列表
export function fetchPinTuanOrderListByParentId(data) {
  return request({
    url: '/pin/tuan/order/fetchPinTuanOrderListByParentId',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/groupBuy.js